import type { ConceptDef } from '../types';

export const tactShapes: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-shapes',
  label: 'Expressive Shapes',
  category: 'Expressive',
  description: 'Show a shape; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '⭕', hint: 'circle' },
      { prompt: '◼', hint: 'square' },
      { prompt: '▲', hint: 'triangle' },
      { prompt: '★', hint: 'star' },
      { prompt: '❤', hint: 'heart' },
      { prompt: '◆', hint: 'diamond' },
    ],
  },
};
